import './styles.css';

import React, { useEffect, useRef, useState } from 'react';
import Grid from '@vtblife/uikit-grid';
import { Dropdown, Modal, Typography, useDropdown, Button } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import { InformationsEnum, InformationsIconEnum } from '@search/gql-selectors/src/infoHelpers/types/InfoModel';
import { InfoModel } from '@search/gql-selectors/src/infoHelpers/types/InfoModel';
import { CoreSvgSpriteIcon } from '@search/vtbeco-frontend-core/view/common/components/CoreSvgSpriteIcon/CoreSvgSpriteIcon';
import classname from '@search/classname/src';

const cn = classname.bind(null, 'DescriptionCell');

interface IProps {
    data: InfoModel | {
        value: React.ReactElement;
        title: string;
        key: InformationsEnum;
        icon?: InformationsIconEnum | InformationsEnum;
        url?: string;
        uppercaseValue?: boolean;
    };
    className?: string;
    withoutTitle?: boolean;
    isModal?: boolean;
    dropdown?: React.ReactElement;
}

const Control: React.FC = ({ children }) => {
    const { toggle, registerControl } = useDropdown();
    const control = useRef<HTMLSpanElement | null>(null);

    useEffect(() => {
        registerControl(control.current as HTMLElement);
    }, [ registerControl ]);

    return (<span
        ref={control}
        onMouseEnter={toggle}
        onMouseLeave={toggle}
    >
        {children}
    </span>);
};

export const DescriptionCell: React.FC<IProps> = ({
    data,
    className,
    withoutTitle = false,
    dropdown = null,
    isModal = false
}) => {
    const [ modal, setModal ] = useState(false);

    const value = dropdown ? (<Dropdown>
        <Control>
            <div data-test='infoItemValue' style={{ margin: 0, padding: 0 }}>
                <Typography
                    tag={data.url ? 'a' : 'div'}
                    // @ts-ignore
                    href={data.url}
                    variant='primary'
                    className={cn('value', { uppercase: data.uppercaseValue, withoutTitle })}
                >
                    {data.value}
                    {<span style={{ marginLeft: '4px' }}>
                        <Icon name='information-circle' size='s' color='hsl(251, 17%, 75%)' />
                    </span>}
                </Typography>
            </div>
        </Control>
        <Dropdown.Content>
            <div style={{ maxWidth: '280px' }}>
                {dropdown}
            </div>
        </Dropdown.Content>
    </Dropdown>) : (
        <div data-test='infoItemValue' style={{ margin: 0, padding: 0 }}>
            <Typography
                tag={data.url ? 'a' : 'div'}
                // @ts-ignore
                href={data.url}
                variant='primary'
                className={cn('value', { uppercase: data.uppercaseValue, withoutTitle })}
            >
                {data.value}
            </Typography>
        </div>
    );

    const content = isModal ? (
        <div data-test='infoItemValue' onClick={() => setModal(true)}>
            <Typography
                tag={data.url ? 'a' : 'div'}
                // @ts-ignore
                href={data.url}
                variant='primary'
                className={cn('value', { uppercase: data.uppercaseValue, withoutTitle })}
            >
                {data.value}
                {<span style={{ marginLeft: '4px' }}>
                    <Icon name='information-circle' size='s' color='hsl(251, 17%, 75%)' />
                </span>}
            </Typography>
            <Modal opened={modal} size='s' onClose={() => setModal(false)}>
                {dropdown}
                <div className={cn('btn')}>
                    <Button
                        onClick={() => setModal(false)}
                        variant='secondary'
                        size='s'
                        fullWidth
                    >
                        Свернуть
                    </Button>
                </div>
            </Modal>
        </div>
    ) : value;

    return (
        <Grid.Cell>
            <div className={cn('', undefined, className)}>
                <div className={cn('icon')}>
                    <CoreSvgSpriteIcon name={data.icon ?? data.key} />
                </div>
                <div data-test='infoItem' className={cn('body', { withoutTitle })}>
                    <div data-test='infoItemTitle' style={{ margin: 0, padding: 0 }}>
                        <Typography
                            variant='secondary-alone'
                            color='secondary'
                        >
                            {data.title}
                        </Typography>
                    </div>
                    {content}
                </div>
            </div>
        </Grid.Cell>
    );
};
